// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_steps__dnZKV {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f5f7fb;
  border-radius: 12px;
  border: 1px solid #e1e6ee;
}

.styles_step__MicXI {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #94a3b8;
  font-weight: 500;
  text-align: center;
}

.styles_stepNumber__Jzuy8 {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  background-color: transparent;
  transition: all 0.3s ease;
}

.styles_activeStep__RxZIo {
  color: #0d6efd;
}

.styles_completedStep__8j8sF {
  color: #16a34a; /* Verde */
}

.styles_completedStep__8j8sF .styles_stepNumber__Jzuy8 {
  background-color: #16a34a;
  border-color: #16a34a;
  color: #ffffff;
}

.styles_checkIcon__Wh\\+YT {
  font-size: 20px !important;
  color: #ffffff !important;
}

.styles_stepLabel__hh6kn {
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .styles_steps__dnZKV {
    flex-direction: column;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/PisCofins/StepsIndicator/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".steps {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f5f7fb;\n  border-radius: 12px;\n  border: 1px solid #e1e6ee;\n}\n\n.step {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: #94a3b8;\n  font-weight: 500;\n  text-align: center;\n}\n\n.stepNumber {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  background-color: transparent;\n  transition: all 0.3s ease;\n}\n\n.activeStep {\n  color: #0d6efd;\n}\n\n.completedStep {\n  color: #16a34a; /* Verde */\n}\n\n.completedStep .stepNumber {\n  background-color: #16a34a;\n  border-color: #16a34a;\n  color: #ffffff;\n}\n\n.checkIcon {\n  font-size: 20px !important;\n  color: #ffffff !important;\n}\n\n.stepLabel {\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .steps {\n    flex-direction: column;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"steps": `styles_steps__dnZKV`,
	"step": `styles_step__MicXI`,
	"stepNumber": `styles_stepNumber__Jzuy8`,
	"activeStep": `styles_activeStep__RxZIo`,
	"completedStep": `styles_completedStep__8j8sF`,
	"checkIcon": `styles_checkIcon__Wh+YT`,
	"stepLabel": `styles_stepLabel__hh6kn`
};
export default ___CSS_LOADER_EXPORT___;
